import { Guides } from "./components/guides.js";
import { GifPlayer } from "./components/gif-player.js";
import { Modal } from "./components/modal.js";
import { Overlay } from "./components/overlay.js";
import { CarouselNav } from "./components/carousel-nav.js";
import "media-chrome";
import { VideoPlayer } from "./components/video-player.js";

/* -------------------------------------------------- */
/* 🙂 General */
/* -------------------------------------------------- */

const isReducedMotion = window.matchMedia(
	"(prefers-reduced-motion: reduce)"
).matches;

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides();

/* -------------------------------------------------- */
/* 🎬 GIF Player */
/* -------------------------------------------------- */

new GifPlayer();

/* -------------------------------------------------- */
/* 🪟 Modal */
/* -------------------------------------------------- */

new Modal();

/* -------------------------------------------------- */
/* 📋 Overlay */
/* -------------------------------------------------- */

new Overlay();

/* -------------------------------------------------- */
/* ◀▶ Carousel Navigation */
/* -------------------------------------------------- */

new CarouselNav();

/* -------------------------------------------------- */
/* 🎥 Video Player */
/* -------------------------------------------------- */

new VideoPlayer();

/* -------------------------------------------------- */
/* 🦥 Lazy loading */
/* -------------------------------------------------- */

document.querySelectorAll('[loading="lazy"]').forEach((element) => {
	const animateIn = () => {
		element.classList.add("is-loaded");
	};

	if (element.complete || element.readyState >= 3) {
		animateIn();
	} else {
		element.addEventListener("load", animateIn);
		element.addEventListener("loadeddata", animateIn);
	}
});
